import { render, staticRenderFns } from "./SensitiveWord.vue?vue&type=template&id=bfc58b86&scoped=true&"
import script from "./SensitiveWord.vue?vue&type=script&lang=js&"
export * from "./SensitiveWord.vue?vue&type=script&lang=js&"
import style0 from "./SensitiveWord.vue?vue&type=style&index=0&id=bfc58b86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc58b86",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/agent/workspace/98-prod-frontend-deploy-tke/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfc58b86')) {
      api.createRecord('bfc58b86', component.options)
    } else {
      api.reload('bfc58b86', component.options)
    }
    module.hot.accept("./SensitiveWord.vue?vue&type=template&id=bfc58b86&scoped=true&", function () {
      api.rerender('bfc58b86', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sensitive/SensitiveWord.vue"
export default component.exports